import i18n from '@/i18n';
import SystemMessage from './SystemMessage'; //$IMPORT$

export default () => [
  {
    resourceName: i18n.t('message-index-1992f2b820cac0a0c-1'),
    routerUrl: '/message',
    resourceIcon: '',
    type: '2',
    buttons: [],
    noparent: true,
    children: [
      SystemMessage(), //$MORE$
    ],
  },
];
